module.exports = __webpack_public_path__ + "static/media/icon_save.653bab4a.svg";